
export const WORK_DATA_LIST= 'WORK_DATA_LIST';
export const WORK_DATA_LIST_SUCCESS= 'WORK_DATA_LIST_SUCCESS';
export const WORK_DATA_LIST_FAILED= 'WORK_DATA_LIST_FAILED';

